module.exports = __webpack_public_path__ + "media/images/shape-bg-1bcbaf2f08ec034731f5d26a20a7e57f.png";